import { Component, inject } from '@angular/core';

import { FormsModule } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';

@Component({
    selector: 'app-reset-password',
    imports: [FormsModule],
    templateUrl: './reset-password.component.html'
})
export class ResetPasswordComponent {
  private http = inject(HttpClient);
  private toastr = inject(ToastrService);
  private router = inject(Router);

  member = { email: '', birthday: '' };

  async sendMail(): Promise<void> {
    try {
      await firstValueFrom(
        this.http.post<any>(`${environment.apiBaseUrl}/member/reset/email`, this.member, {
          headers: { '__skipAuthInterceptor': 'true' },
        })
      );
      this.toastr.success('パスワード再設定メールを送信しました。', '', { timeOut: 5000 });
      await this.router.navigate(['/login']);
    } catch {
      this.toastr.warning('パスワード再設定メールの送信に失敗しました。再度お試しください。', '', { timeOut: 5000 });
    }
  }
}
